import ProtectedRoute from "components/auth/ProtectedRoute";
import Layout from "components/layout/Layout";
import LandingPage from "pages/landingPage/LandingPage";
import { lazy } from "react";

import { Navigate, Route, Routes } from "react-router-dom";

// const LandingPage = lazy(() => import("../pages/landingPage/LandingPage"));
const Login = lazy(() => import("../components/login/Login"));

// Dashboard Pages
const Dashboard = lazy(() => import("../components/dashboard/Dashboard"));
const Outlet = lazy(() => import("../components/outlets/Outlet"));
const Observatory = lazy(() => import("../components/observatory/Observatory"));
const OnBoarding = lazy(() => import("../components/onboarding/OnBoarding"));
const RunCampaign = lazy(() => import("../components/runCampaign/RunCampaign"));
const Campaigns = lazy(() => import("../components/campaigns/Campaigns"));
const Products = lazy(() => import("../components/products/Products"));
const Users = lazy(() => import("../components/users/Users"));
const Sales = lazy(() => import("../components/sales/Sales"));
const ClientStats = lazy(() => import("../components/clientStats/ClientStats"));
const CampaignStats = lazy(() =>
  import("../components/campaignStats/CampaignStats")
);
const Commerce = lazy(() => import("../components/commerce/Commerce"));
const Geography = lazy(() => import("../components/geography/Geography"));
const Onboard = lazy(() => import("../components/onboard/Onboard"));

// Wholesaler Routes
const Wholesaler = lazy(() => import("../components/wholesaler/Wholesaler"));
const WholesalerCampaigns = lazy(() =>
  import("../components/wholeSalerCampaigns/WholesalerCampaigns")
);
const WholesalerStats = lazy(() =>
  import("../components/wholeSalerStats/WholesalerStats")
);

// Fulfillment Center
const FcHome = lazy(() =>
  import("../components/fulfillmentCenter/fcHome/FcHome")
);
const FcCampaignStats = lazy(() =>
  import("../components/fulfillmentCenter/fcCampaignStats/FcCampaignStats")
);

// Territory Development Rep
const TdrHome = lazy(() => import("../components/TDR/tdrHome/TdrHome"));
const TdrCampaignStats = lazy(() =>
  import("../components/TDR/tdrCampaignStats/TdrCampaignStats")
);

// Territory Market Manager
const TmmHome = lazy(() => import("../components/TMM/tmmHome/TmmHome"));

// Client
const ClientCampaigns = lazy(() =>
  import("../components/CLIENT/clientCampaigns/ClientCampaigns")
);
const ClientCampaignStats = lazy(() =>
  import("../components/clientTabs/clientCampaignStats/ClientCampaignStats")
);
const ProductPerformance = lazy(() =>
  import("../components/productPerformance/ProductPerformance")
);
const Orders = lazy(() => import("../components/orders/Orders"));
const Settings = lazy(() => import("../components/settings/Settings"));
const AgentCampaignStats = lazy(()=> import("../components/agentCampaignStats/AgentCampaignStats"));
const ClientHome = lazy(()=> import("../components/CLIENT/clientHome/ClientHome"));
const OrderAnalytics = lazy(()=> import("../components/orders/OrderAnalytics"));
const AgentAnalytics = lazy(()=> import("../components/users/AgentAnalytics"));
const ClientManagerHome = lazy(()=> import("../components/CLIENT/clientManagerHome/ClientManagerHome"));
const ClientOrders = lazy(()=> import("../components/CLIENT/clientOrders/ClientOrders"));
const DownloadPolicy = lazy(()=> import("../privacyPolicy/DownloadPolicy"));
const AgentRoutes = lazy(() => import("../components/agentRoutes/AgentRoutes"));
const TaRoutes = lazy(() => import("../components/agentRoutes/TaRoutes"));
const Broadcast = lazy(()=> import("../components/broadcast/Broadcast"));
const Stocks = lazy(() => import("../components/stocks/Stocks"));
const StockAnalysis = lazy(() => import("../components/stocks/StockAnalysis"));
const AgentManagerHome = lazy(() => import("../components/agentManager/AgentManagerHome"));
const TradeCalls = lazy(() => import("../components/tradecalls/TradeCalls"));
const AgentOrdersManager = lazy(() => import("../components/orders/AgentOrdersManager"));
const Calls = lazy(() => import("../components/telesales/Calls"));
const TelesalesDash = lazy(() => import("../components/telesales/TelesalesDash"));
const FocusBrands = lazy(() => import("../components/focusBrands/FocusBrands"));
const Rider = lazy(()=>import("../components/fulfillment/Rider"));
const FulfillmentDash = lazy(() => import("../components/fulfillment/FulfillmentDash"));
const Schedule = lazy(()=> import("../components/schedule/Schedule"));
const UserRider = lazy(()=> import("../components/users/UserRider"));
const ReviewOrders = lazy(()=> import("../components/orders/ReviewOrders"));
const BrandIntelligenceDash = lazy(()=> import("../components/tradecalls/BrandIntelligenceDash"));
const BroadcastReport = lazy(()=> import("../components/broadcast/BroadcastReport"));
const Manifest = lazy(()=> import("../components/schedule/Manifest"));
const AgentPerfomance = lazy(()=> import("../components/agentManager/AgentPerformance"));
const CustomerAnalytics = lazy(()=> import("../components/orders/CustomerAnalytics"));
const Rebate = lazy(()=> import("../components/rebates/Rebate"));

export default function RouteIndex() {
  return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/onboard" element={<Onboard />} />

        {/* PROTECTED ROUTES UNDER LAYOUT */}
        <Route
          element={
            <ProtectedRoute>
                <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/outlet" element={<Outlet />} />
          <Route path="/observatory" element={<Observatory />} />
          <Route path="/onboarding" element={<OnBoarding />} />
          <Route path="/runCampaign" element={<RunCampaign />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/products" element={<Products />} />
          <Route path="/users" element={<Users />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/clientStats" element={<ClientStats />} />
          <Route path="/campaignStats" element={<CampaignStats />} />
          <Route path="/commerce" element={<Commerce />} />
          <Route path="/geography" element={<Geography />} />
          <Route path="/productPerformance" element={<ProductPerformance />} />
          <Route path="/wholesaler" element={<Wholesaler />} />
          <Route
            path="/wholesalerCampaigns"
            element={<WholesalerCampaigns />}
          />
          <Route path="/wholesalerStats" element={<WholesalerStats />} />

          <Route path="/clientHome" element={<ClientHome/>}/>
          <Route path="/fcHome" element={<FcHome />} />
          <Route path="/fcCampaignStats" element={<FcCampaignStats />} />
          <Route path="/tdrHome" element={<TdrHome />} />
          <Route path="/tdrCampaignStats" element={<TdrCampaignStats />} />
          <Route path="/clientCampaigns" element={<ClientCampaigns/>} />
          <Route
            path="/clientCampaignStats"
            element={<ClientCampaignStats />}
          />
          <Route path="/tmmHome" element={<TmmHome />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orderAnalytics" element={<OrderAnalytics/>}/>
          <Route path="/agentAnalytics" element={<AgentAnalytics/>}/>
          <Route path="/agentCampaignStats" element={<AgentCampaignStats/>}/>
          <Route path="/settings" element={<Settings />} />
          <Route path="/clientManagerHome" element={<ClientManagerHome/>}/>
          <Route path="/clientOrders" element={<ClientOrders/>}/>
          <Route path="/privacy-policy/download" element={<DownloadPolicy policyKey="download"/>}/>
          <Route path="/agentRoutes" element={<AgentRoutes/>}/>
          <Route path="/taRoutes" element={<TaRoutes/>}/>
          <Route path="/broadcast" element={<Broadcast/>}/>
          <Route path="/stocks" element={<Stocks/>}/>
          <Route path="/stockAnalysis" element={<StockAnalysis/>}/>
          <Route path="/agentManagerHome" element={<AgentManagerHome/>}/>
          <Route path="/tradeCalls" element={<TradeCalls/>}/>
          <Route path="/agentOrdersManager" element={<AgentOrdersManager/>}/>
          <Route path="/calls" element={<Calls/>}/>
          <Route path="/telesalesDash" element={<TelesalesDash/>}/>
          <Route path="/focusBrands" element={<FocusBrands/>}/>
          <Route path="/rider" element={<Rider/>}/>
          <Route path="/fulfillmentDash" element={<FulfillmentDash/>}/>
          <Route path="/schedule" element={<Schedule/>}/>
          <Route path="/userRider" element={<UserRider/>}/>
          <Route path="/reviewOrders" element={<ReviewOrders/>}/>
          <Route path="/brandIntelligenceDash" element={<BrandIntelligenceDash/>}/>
          <Route path="/broadcastReport/:broadcastId" element={<BroadcastReport/>}/>
          <Route path="/manifest" element={<Manifest/>}/>
          <Route path="/agentPerformance" element={<AgentPerfomance/>}/>
          <Route path="/customerAnalytics" element={<CustomerAnalytics/>}/>
          <Route path="/rebate" element={<Rebate/>}/>
        </Route>
        {/* Optional fallback route */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
  );
}
